<template>
  <div class="exhiinfo">
    <h3>{{ $t('exhiInformat.exhibitor') }} <span>{{ $t('common.required1') }}<i>*</i>{{ $t('common.required2') }}</span></h3>
    <div class="classify">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('exhiInformat.companytab')" name="first">
            <company />
        </el-tab-pane>
 
        <el-tab-pane :label="$t('exhiInformat.boothtab')" name="second"> <booth/> </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import company from "./company.vue";
import booth from "./booth.vue"
export default {
  data() {
    return {
      activeName: 'first',
    };
  },

  components: {
    company,
    booth
  },

  computed: {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.exhiinfo {
  // border: 1px solid red;
  min-height: calc(100vh - 74px - 40px);
  box-sizing: border-box;
  padding: 18px 0 0 26px;
  background: white;
  h3 {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    span {
      margin-left: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      i {
        font-style: normal;
        color: red;
      }
    }
  }
  .classify {
    margin-top: 17px;
  }
}
</style>
<style  scoped>
.classify >>> .el-tabs__nav-wrap::after {
  height: 1px ;
  background: #E8E8E8;
}
</style>
